<template>
    <ContainerLayout page="0">
        <template v-slot:navbar>
            <nav class="navbar navbar-expand navbar-light bg-white text-dark">
                <router-link :to="{ path: '', query: { ...$route.query } }" class="nav-link" @click.prevent="goBack">
                    <font-awesome-icon icon="arrow-left" class="text-dark" />
                </router-link>
                <div class="navbar-nav mr-auto">
                    <li class="nav-item">
                        <h6 class="nav-link mb-0 text-dark font-weight-bold">
                            {{ $route.meta.title }}
                        </h6>
                    </li>
                </div>
            </nav>
            <hr class="my-0" style="height: 1.5px;">
        </template>
        <div class="content px-1">
            <label class="mb-4">{{ $t('Please enter destination information') }}</label>
            <Form @submit="handleRegister" :validation-schema="schema" :initial-values="initialValues" autocomplete="off">
                <div class="form-group">
                    <label style="font-weight: 600;" for="type">{{ $t('Location') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="location_id" as="select" class="form-control">
                        <option value="" disabled selected>{{ $t('Select Location') }}</option>
                        <option v-for="(location, index) in locations" :key="index" :value="location.id">
                            {{ location.current_name + ' - ' + (location.airport_code ? location.airport_code + ', ' : '') +
                                location.city + ', ' + location.province }}
                        </option>
                    </Field>
                    <ErrorMessage name="location_id" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="name">{{ $t('Destination Name') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="name" type="text" class="form-control" />
                    <ErrorMessage name="name" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="brand">{{ $t('Label Name') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="brand" type="text" class="form-control" />
                    <ErrorMessage name="brand" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="phone">{{ $t('Phone Number') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="phone" type="text" class="form-control" />
                    <ErrorMessage name="phone" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="address">{{ $t('Address') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="address" type="text" class="form-control" />
                    <ErrorMessage name="address" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="receiver_name">{{ $t('PIC Name') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="receiver_name" type="text" class="form-control" />
                    <ErrorMessage name="receiver_name" class="error-feedback" />
                </div>
                <div class="form-group">
                    <label style="font-weight: 600;" for="receiver_phone">{{ $t('PIC Phone Number') }} <sup
                            class="text-danger">*</sup></label>
                    <Field name="receiver_phone" type="text" class="form-control" />
                    <ErrorMessage name="receiver_phone" class="error-feedback" />
                </div>
                <div class="form-group pt-3">
                    <button class="btn btn-main btn-block" :disabled="loading">
                        <span>{{ $t('Register') }}</span>
                    </button>
                </div>
            </Form>
        </div>
    </ContainerLayout>
</template>
  
<script>
import ContainerLayout from "../../ContainerLayout.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import CompanyService from "@/services/company.service";

export default {
    name: "CompanyRegistration",
    components: {
        ContainerLayout,
        Form,
        Field,
        ErrorMessage,
    },
    data() {
        const schema = yup.object().shape({
            location_id: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Location") })),
            name: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Name") })),
            brand: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Label") })),
            phone: yup
                .number(this.$t("Data is invalid!", { data: this.$t("Phone Number") }))
                .typeError(this.$t("Data is invalid!", { data: this.$t("Phone Number") }))
                .required(this.$t("Data is required!", { data: this.$t("Phone Number") })),
            address: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("Address") })),
            receiver_name: yup
                .string()
                .required(this.$t("Data is required!", { data: this.$t("PIC Name") })),
            receiver_phone: yup
                .number(this.$t("Data is invalid!", { data: this.$t("PIC Phone Number") }))
                .typeError(this.$t("Data is invalid!", { data: this.$t("PIC Phone Number") }))
                .required(this.$t("Data is required!", { data: this.$t("PIC Phone Number") })),
        });

        return {
            initialValues: {
                location_id: "",
                name: "",
                brand: "",
                phone: "",
                address: "",
                receiver_phone: "",
            },
            loading: false,
            locations: [],
            schema,
        };
    },
    computed: {
        currentUser() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user : null;
        },
        currentCompany() {
            return localStorage.getItem('loggedData') ? JSON.parse(localStorage.getItem('loggedData')).user.company : null;
        },
    },
    created() {
        if (this.currentUser && this.currentUser.company_id == null) {
            this.$router.push("/");
        }

        CompanyService.getAllLocation()
            .then((response) => {
                this.locations = response.data.data;
            })
            .catch(() => {
                // console.error(error);
            });
    },
    methods: {
        goBack() {
            this.navigateBackOrHome();
        },

        handleRegister(branch) {
            this.loading = true;
            let loader = this.$loading.show();

            let company_id = { company_id: this.currentCompany.id };
            branch = { ...branch, ...company_id };
            CompanyService
                .addBranch(branch)
                .then((response) => {
                    this.loading = false;
                    loader.hide();
                    if (response.data.status == 'success') {
                        let company = response.data.data.company;
                        let loggedData = JSON.parse(localStorage.getItem('loggedData'));
                        loggedData.user.company = company;
                        localStorage.setItem('loggedData', JSON.stringify(loggedData));

                        if (localStorage.getItem('branch') == null) {
                            localStorage.setItem('branch', JSON.stringify(response.data.data));
                        }

                        this.$vueAlert.alert(response.data.message, null, 'success').then(() => {
                            // this.$router.go();
                            this.$router.push("/");
                        });
                    } else {
                        this.$vueAlert.alert(response.data.message, null, 'error');
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    loader.hide();

                    let errorMessage = this.$t('An error occurred');
                    if (error.response) {
                        if (error.response.status == 401) {
                            this.$store.dispatch("auth/logout");
                            this.$router.push('/login');
                            return; // Exit the function after handling 401
                        }

                        // Check if the message is available in the error response
                        if (error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.statusText) {
                            // Fallback to statusText if message is not available
                            errorMessage = error.response.statusText;
                        }
                    } else if (error.message) {
                        // Fallback to error.message if response is not available
                        errorMessage = error.message;
                    }

                    this.$vueAlert.alert(errorMessage, null, 'error');
                });
        },
    }
};
</script>

<style scoped>
label {
    display: block;
    margin-top: 10px;
}

.form-control {
    border-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}
</style>
  